<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 >
          <report-list-item 
            v-for="(r,i) in reports" 
            :key="r.reportID" 
            :report-data="r"
            :contained-by="containedBy"
            :is-searching="isSearching"
            :id="'reportlistitem' + i"
            :search-props="searchProps"
            :search-items="searchItems"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ReportListItem from './report-list-item.vue'

export default {
  name: 'report-list',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  props: ['reports', 'isSearching', 'containedBy', 'searchProps', 'searchItems'],
  components: {
    ReportListItem
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/report-list.vue